/* Use typescript for the behaviour/backend work here */
import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  standalone: false
})

export class NavbarComponent implements OnInit {
  @Input() currentTab!: 'home1' | 'home2';
  @Output() tabChanged = new EventEmitter<'home1' | 'home2'>();
  isLoggedIn = false;
  constructor(private router: Router, private authService: AuthService) { }


  selectTab(tab: 'home1' | 'home2') {

    this.tabChanged.emit(tab);
    if (this.router.url !== '/') {
      this.router.navigateByUrl('/');
    }

  }
  navUser = { name: environment.brandName };
  photoUrl: string = '';
  navLinks = [
    { link: 'partners', text: 'Partners' },
    { link: 'listings', text: 'Listings' },
    { link: 'listing', text: 'Listing' },
    { link: '/otp', text: 'Verify' },
    { link: 'paypal-plan', text: 'Create Plan' },
    { link: 'plan-list', text: 'Billing Plans' },
    { link: '/pubs', text: 'Pubs' },
    { link: '/pubs/manage', text: 'Your Lounges' },
  ];
  contactsFileFound = false;
  userLoaded = true;
  isHomeGHUser = true;
  loggedIn = false;

  myHomepagePath = '';

  ngOnInit(): void {
    this.authService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    });
    const hostname = window.location.hostname;
    // If NOT on admin subdomain, hide admin routes
    if (!hostname.startsWith('admin.')) {
      const adminRoutes = ['partners', 'paypal-plan', 'plan-list'];
      this.navLinks = this.navLinks.filter(link => !adminRoutes.includes(link.link));
    }
  }

  get visibleNavLinks() {
    if (this.isLoggedIn) {
      return this.navLinks;
    }
    return this.navLinks.filter(link => link.text.includes('Verify') || link.text.includes('Create'));
  }

  logout() {
    this.authService.logout();
  }
}
